'use client';
// ──────────────────────────────────────────────────────
// Protected Admin Layout — JWT auth check (client-side)
// Redirects to /admin/login if no valid token
// ──────────────────────────────────────────────────────
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { isAuthenticated, adminLogout } from '@/lib/admin-auth';
import { AdminShell } from './AdminShell';

export default function ProtectedAdminLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const router = useRouter();
    const [authed, setAuthed] = useState<boolean | null>(null);

    useEffect(() => {
        isAuthenticated().then((ok) => {
            if (!ok) {
                router.replace('/admin/login');
            } else {
                setAuthed(true);
            }
        });
    }, [router]);

    if (authed === null) {
        return (
            <div className="min-h-dvh flex items-center justify-center"
                style={{ background: '#f8f9fb' }}>
                <div className="text-center">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        src="/branding/qio-logo.jpeg"
                        alt="QIO"
                        width={56}
                        height={56}
                        className="mx-auto mb-5 rounded-xl"
                        style={{ border: '1px solid #e5e7eb' }}
                    />
                    <div className="w-7 h-7 border-[2.5px] rounded-full animate-spin mx-auto mb-3"
                        style={{ borderColor: '#e5e7eb', borderTopColor: '#0ea5a5' }} />
                    <p className="text-sm font-medium" style={{ color: '#64748b' }}>جاري التحميل...</p>
                </div>
            </div>
        );
    }

    return <AdminShell onLogout={async () => { await adminLogout(); router.replace('/admin/login'); }}>{children}</AdminShell>;
}
